import type { UserDetails, WorldDetails } from '@/components/Worlds/types'
import Avatar from '@/components/Worlds/UI/Avatar/Avatar'
import AvatarWithIcon from '@/components/Worlds/UI/Avatar/AvatarWithIcon'

export default function NotificationAvatar({
  user,
  relatedUser,
  world,
}: {
  user: UserDetails
  relatedUser: UserDetails | null
  world: Pick<WorldDetails, 'primaryColor' | 'iconUrl'> | null
}): JSX.Element {
  const userToShow = relatedUser ?? user
  if (world != null) {
    return <AvatarWithIcon size="sm" user={userToShow} iconEntity={world} hideOnlineBadge />
  }
  return <Avatar size="sm" user={userToShow} />
}
